/* ==========================================================
   Affiorezuna cart guard
   Items added from the product page carry a hidden "_moq" property.
   If a customer lowers one below that minimum in the cart (page or
   drawer), we set it back to the minimum and explain why.
   Setting the quantity to 0 (removing the item) is still allowed.
   ========================================================== */
(function () {
  'use strict';
  if (window.__afCartGuard) return;
  window.__afCartGuard = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var busy = false;
  var KEY = 'afMoqNotice';

  function notice(min) {
    var t = document.createElement('div');
    t.className = 'af-toast is-visible';
    t.setAttribute('role', 'status');
    t.style.top = 'calc(var(--af-hdr-h, 76px) + 12px)';
    t.textContent = 'Personalized favors have a minimum of ' + min + ' pieces per design, so we kept ' + min + ' in your cart.';
    document.body.appendChild(t);
    setTimeout(function () { t.classList.remove('is-visible'); }, 6000);
    setTimeout(function () { t.remove(); }, 6600);
  }

  function check() {
    if (busy) return;
    nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var fixes = (cart.items || []).filter(function (it) {
          var min = it.properties && parseInt(it.properties._moq, 10);
          return min && it.quantity > 0 && it.quantity < min;
        });
        if (!fixes.length) return;
        busy = true;
        var chain = Promise.resolve();
        fixes.forEach(function (it) {
          chain = chain.then(function () {
            return nativeFetch(root + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: it.key, quantity: parseInt(it.properties._moq, 10) })
            });
          });
        });
        chain.then(function () {
          try { sessionStorage.setItem(KEY, fixes[0].properties._moq); } catch (e) {}
          window.location.reload();
        });
      })
      .catch(function () {});
  }

  /* Re-check after any cart update the theme makes */
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var req = nativeFetch.apply(window, arguments);
    if (/\/cart\/(change|update)/.test(url)) {
      req.then(function (r) { if (r.ok) setTimeout(check, 50); }).catch(function () {});
    }
    return req;
  };

  function start() {
    var shown = null;
    try { shown = sessionStorage.getItem(KEY); sessionStorage.removeItem(KEY); } catch (e) {}
    if (shown) notice(shown);
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('pageshow', function (e) { if (e.persisted) check(); });
})();
